import { CatalogManagementModel } from "@app/catalog";

export class CatalogDataChangedMessage {

    public catalogManagementData: CatalogManagementModel;

    constructor();
    constructor(catalogManagementData: CatalogManagementModel);
    constructor(catalogManagementData?: CatalogManagementModel) {

        if (catalogManagementData !== undefined)
        {
            this.catalogManagementData = catalogManagementData;
        }
    }
}